import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Epic%20Chinese%20manhua%20cityscape%20background%2C%20modern%20city%20with%20magical%20energy%20auras%2C%20warm%20orange%20and%20golden%20light%20rays%2C%20dramatic%20sky%20with%20fantasy%20elements%2C%20stylized%20illustration%2C%20clean%20composition%2C%20anime%20art%20style%2C%20inspiring%20atmosphere&width=1920&height=800&seq=hero-bg-comic&orientation=landscape"
          alt="全职法师漫画 - 073漫画网"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium mb-6 tracking-wide">
          热门推荐 · 每周更新
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
          全职法师
        </h1>
        <p className="text-background-100/90 text-sm md:text-base max-w-xl mb-8 leading-relaxed">
          一觉醒来，世界巨变。曾经的普通学生莫凡，意外觉醒了全系魔法天赋，从此踏上逆天改命的魔法之路。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/article/1"
            className="px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-all duration-200 whitespace-nowrap"
          >
            开始阅读
          </Link>
          <Link
            to="/category/all"
            className="px-8 py-3 rounded-full bg-background-50/20 hover:bg-background-50/30 backdrop-blur-sm text-background-50 font-medium text-sm border border-background-50/30 transition-all duration-200 whitespace-nowrap"
          >
            浏览全部漫画
          </Link>
        </div>

        <div className="flex items-center gap-8 mt-10">
          <div className="text-center">
            <p className="text-background-50 text-xl md:text-2xl font-bold">9.6</p>
            <p className="text-background-100/70 text-xs">评分</p>
          </div>
          <div className="w-px h-8 bg-background-50/30"></div>
          <div className="text-center">
            <p className="text-background-50 text-xl md:text-2xl font-bold">1280</p>
            <p className="text-background-100/70 text-xs">章节</p>
          </div>
          <div className="w-px h-8 bg-background-50/30"></div>
          <div className="text-center">
            <p className="text-background-50 text-xl md:text-2xl font-bold">3258万</p>
            <p className="text-background-100/70 text-xs">阅读量</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/70 text-2xl"></i>
      </div>
    </section>
  );
}